import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AuthContext } from '../auth/AuthContext';

export const GuestRoute: React.FC = () => {
  const { authUser, loading } = React.useContext(AuthContext);
  if (loading) return null; // or spinner
  return authUser ? <Navigate to="/staff" replace /> : <Outlet />;
};

export const ProtectedRoute: React.FC = () => {
  const { authUser, loading } = React.useContext(AuthContext);
  const location = useLocation();
  if (loading) return null;
  return authUser ? <Outlet /> : <Navigate to="/login" replace state={{ from: location.pathname }} />;
};

export const RoleRoute: React.FC<{ roles: Array<'admin'|'editor'|'staff'> }> = ({ roles }) => {
  const { authUser, loading } = React.useContext(AuthContext);
  const location = useLocation();
  if (loading) return null;
  const ok =
    authUser &&
    roles.some(r => (authUser.roles as any)[r]);

  return ok ? <Outlet /> : <Navigate to="/login" replace state={{ from: location.pathname }} />;
};
